import {
  FETCH_BFS_DATA_REQUEST,
  FETCH_BFS_DATA_SUCCESS,
  FETCH_BFS_FOR_SHIPMENT_DATA_REQUEST,
  FETCH_BFS_FOR_SHIPMENT_DATA_SUCCESS
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  isFetching: true,
  buyerfulfilments: [],
  buyerFulfilmentsShipment: [],
  adminAddress: {},
  page: 1,
  count: 0
};

export const buyerFulfilmentsReducer = createReducer(initialState, {
  [FETCH_BFS_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false,
      isAllChecked: false
    };
  },
  [FETCH_BFS_DATA_REQUEST]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  },
  [FETCH_BFS_FOR_SHIPMENT_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false
    };
  },
  [FETCH_BFS_FOR_SHIPMENT_DATA_REQUEST]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  }
});

export default buyerFulfilmentsReducer;
